<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)" *ngIf="!carInformacionInicial">
  <p-accordionTab header="{{'GARANTIASIDONEAS.LBL_INFOFONDOGARANTIAS'|translate}}" [selected]="tabSeleccionado === 'DATOSPRINCIPALES'">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fPalabraClave"
              name="nomPalabraClave">
          <div class="grid form-group">
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_CODIGO' | translate }}</label>
                <div *ngIf="!garantiasIdoneas">
                  <input type="text" pInputText id="codigo"
                         name="nomCodigo"
                         autocomplete="off"
                         formControlName="codigo"
                         maxlength="6"
                         (blur)="validarCodigo()"
                         codigos-reactive
                  >
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigo.invalid">
                    {{ 'GARANTIASIDONEAS.LBL_CODIGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="codExiste">
                    {{ 'MSG_CODIGOEXISTE' | translate}}
                  </div>
                </div>
                <div *ngIf="garantiasIdoneas && garantiasIdoneas.idGarantiaIdonea">
                  <label class="falso-combo-texto">{{garantiasIdoneas.codigo}}</label>
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_FONDO' | translate }}</label>
                <p-dropdown disableTab  id="idFondoGarantia" name="nomidFondoGarantia" [options]="listasFondosGarantias"
                            placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                            [autoWidth]="false" formControlName="idFondoGarantia"
                ></p-dropdown>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFondoGarantia.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_FONDO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_CODIGOSHIVAM' | translate }}</label>
                <input type="text" pInputText id="codigoShivam"
                       name="nomCodigoShivam"
                       autocomplete="off"
                       formControlName="codigoShivam"
                       [maxlength]="3"
                       appTexto [sinCaracteres]="true"
                       [sinEspacio]="true"
                       [sinPunto]="true"
                       [sinLetras]="true"
                       [sinTildes]="true"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.codigoShivam.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_CODIGOSHIVAM' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>

              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_NOMBRE' | translate }}</label>
                <input type="text" pInputText id="nombre"
                       name="nomNombre"
                       autocomplete="off"
                       formControlName="nombre"
                       [maxlength]="500"
                       capitalize-reactive
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.nombre.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_NOMBRE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>

              </div>
            </div>

          </div>
          <div class="grid form-group">

            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_MONTOMINIMO' | translate }}</label>
                <input type="text" pInputText id="montoMinimo"
                       name="nommontoMinimo"
                       autocomplete="off"
                       formControlName="montoMinimo"
                       (blur)="validarValor($event, true)"
                       numero-decimal-reactive
                       [decimales]="6" [minimo]="0" [entero]="7"
                       maxlength="14">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMinimo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_MONTOMINIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="!rangoMontoValido">
                  {{ 'GARANTIASIDONEAS.MSG_ERRORRANGO' | translate }}
                </div>
              </div>
            </div>

            <div class="col-12 md:col-2 lg:col-2">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_MONTOMAXIMO' | translate }}</label>
                <input type="text" pInputText id="montoMaximo"
                       name="nommontoMaximo"
                       autocomplete="off"
                       formControlName="montoMaximo" numero-decimal-reactive
                       (blur)="validarValor($event, true)"
                       numero-decimal-reactive
                       [decimales]="6" [minimo]="0" [entero]="7"
                      maxlength="14">
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoMaximo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_MONTOMAXIMO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>

              </div>
            </div>
            <div class="col-12 md:col-8 lg:col-8">
              <div class="div-form">
                <label> {{ 'GARANTIASIDONEAS.LBL_DESCRIPCION' | translate }}</label>
                <textarea pInputTextarea
                          id="descripcion"
                          name="nommontoMinimo"
                          formControlName="descripcion"
                          [maxlength]="500"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="grid form-group">
            <div class="col-12 md:col-6 lg:col-6" style="display: flex; align-items: center;">
              <div class="grid form-group" style="padding: 4px 0px; border-radius: 4px; border: 1px solid var(--Neutrales-Gris-30, #C4C4C4);">
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <label class="pl-2"><strong>{{'GARANTIASIDONEAS.LBL_METODOCOBRO' | translate}}</strong></label>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorAnticipado" binary="true" (onChange)="validarAnticipado('Anticipado')"></p-checkbox>
                    <label class="pl-2">{{'GARANTIASIDONEAS.LBL_ANTICIPADO' | translate}}</label>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorAnticipadoAnual" binary="true" (onChange)="validarAnticipado('AnticipadoAnual' )"></p-checkbox>
                    <label class="pl-2">{{'GARANTIASIDONEAS.LBL_ANTICIPADOANUAL' | translate}}</label>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorDiferido" binary="true" (onChange)="validarAnticipado('Diferido' )"></p-checkbox>
                    <label class="pl-2">{{'GARANTIASIDONEAS.LBL_DIFERIDO' | translate}}</label>
                  </div>
                </div>
              </div>

            </div>

            <div class="col-12 md:col-6 lg:col-6">
              <div class="grid form-group" style="padding: 4px 0px; border-radius: 4px; border: 1px solid var(--Neutrales-Gris-30, #C4C4C4);place-items: center">
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorIva" binary="true" (onChange)="validacionPLazoTasa()"></p-checkbox>
                    <label class="pl-2">{{'GARANTIASIDONEAS.LBL_IVAPORCENTAJE' | translate}}</label>
                  </div>
                </div>

                <div class="col-12 md:col-3 lg:col-3" *ngIf="iva">
                  <div class="div-form">
                    <input type="text" pInputText id="iva"
                          name="nomIva"
                          autocomplete="off"
                          formControlName="iva"
                          numero-decimal-reactive
                          [decimales]="2" [minimo]="0" [entero]="3"
                          [maximo]="100"
                          >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.iva.invalid">
                      {{ 'GARANTIASIDONEAS.LBL_IVAPORCENTAJE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <p-checkbox formControlName="indicadorTasa" binary="true" (onChange)="validacionPLazoTasa()"></p-checkbox>
                    <label class="pl-2">{{'GARANTIASIDONEAS.LBL_TASAPORCENTAJE' | translate}}</label>
                  </div>
                </div>

                <div class="col-12 md:col-3 lg:col-3" *ngIf="tasa">
                  <div class="div-form">
                    <input type="text" pInputText id="tasaCobro"
                          name="nomtasaCobro"
                          autocomplete="off"
                          formControlName="tasaCobro"
                          numero-decimal-reactive
                          [decimales]="2" [minimo]="0" [entero]="3"
                          [maximo]="100"
                          >
                    <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tasaCobro.invalid">
                      {{ 'GARANTIASIDONEAS.LBL_TASAPORCENTAJE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style="padding: 4px 8px; border-radius: 4px; border: 1px solid var(--Neutrales-Gris-30, #C4C4C4); margin-top: 10px;">
            <div class="grid form-group">
              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorPeriodoGracia" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorMunicipio" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_MUNICIPIO' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorRut" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_RUT' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorActividades" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_ACTIVIDADES' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorClienteNuevo" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_CLIENTENUEVO' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorClienteRenovado" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_CLIENTERENOVADO' | translate}}</label>
                </div>
              </div>
            </div>
            <div class="grid form-group">
              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorDestino" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_DESTINO' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorPlanPagos" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_PLANPAGO' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorRecogerCrezcamos" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_CREDITOCREZCAMOS' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorCobroPerfil" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_COBROPERFIL' | translate}}</label>
                </div>
              </div>

              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorNotificacionFGA" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_NOTIFICACIONFGA' | translate}}</label>
                </div>
              </div>
              <div class="col-12 md:col-2 lg:col-2">
                <div class="div-form">
                  <p-checkbox formControlName="indicadorGarantiaIdonea" binary="true"></p-checkbox>
                  <label class="pl-2">{{'GARANTIASIDONEAS.LBL_GARANTIAIDONEA' | translate}}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="grid form-group">

            <div class="col-12 md:col-3 lg:col-3" >
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_PLAZOMINIMOMESES' | translate }}</label>
                <input type="text" pInputText id="plazoMinimo"
                       name="nomPlazoMinimo"
                       autocomplete="off"
                       formControlName="plazoMinimo"
                       numero-entero-reactive
                       [maxlength]="3"
                       (blur)="validarPlazos()"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMinimo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_PLAZOMINIMOMESES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
                <div class="p-message p-messages-error p-corner-all"
                     *ngIf="!rangoMininoValido">
                  {{ 'GARANTIASIDONEAS.MSG_ERRORRANGOPLAZO' | translate }}
                </div>
              </div>
            </div>
            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_PLAZOMAXIMOMESES' | translate }}</label>
                <input type="text" pInputText id="plazoMaximo"
                       name="nomPlazoMaximo"
                       autocomplete="off"
                       formControlName="plazoMaximo"
                       numero-entero-reactive
                       [maxlength]="3"
                       (blur)="validarPlazos()"
                >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.plazoMaximo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_PLAZOMAXIMOMESES' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>

            <div class="col-12 md:col-3 lg:col-3">
              <div class="div-form">
                <label>* {{ 'GARANTIASIDONEAS.LBL_PORCENTAJERESPALDO' | translate }}</label>
                <input type="text" pInputText id="porcentajeRespaldo"
                       name="nomPorcentajeRespaldo"
                       autocomplete="off"
                       formControlName="porcentajeRespaldo"
                       numero-decimal-reactive
                       [decimales]="2" [minimo]="0" [entero]="3"
                       [maximo]="100" >
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.porcentajeRespaldo.invalid">
                  {{ 'GARANTIASIDONEAS.LBL_PORCENTAJERESPALDO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
            </div>

            <div class="col-12 md:col-3 lg:col-3 flex align-items-center">
              <div class="div-form flex align-items-center">
                <p-inputSwitch formControlName="indicadorHabilitado"></p-inputSwitch>
                <label class="pl-2">{{'LBL_HABILITADO' | translate}}</label>
              </div>
            </div>

          </div>

            <div class="grid form-footer-buttons">
            <div class="form-group col-12">
              <div *ngIf="!guardando">
                <a (click)="regresar( true)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
                <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate }}"
                        type="submit"
                        pButton></button>
              </div>
              <div *ngIf="guardando">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{'LBL_GUARDANDO' | translate }}</span>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </p-accordionTab>

  <p-accordionTab header="{{'GARANTIASIDONEAS.LBL_INFOPARAMETROS'|translate}}"
                  [selected]="tabSeleccionado === 'TABPAQUETESEGUROS'"
                  [disabled]="!garantiasIdoneas"
                  *ngIf="garantiasIdoneas && garantiasIdoneas.idGarantiaIdonea">

    <p-tabView>

      <p-tabPanel header="{{ 'GARANTIASIDONEAS.LBL_DESTINO' | translate}}"
                  *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorDestino">
        <app-garantia-idoneas-destinos [garantia]="garantiasIdoneas"
                                       *ngIf="garantiasIdoneas.idGarantiaIdonea && garantiasIdoneas.indicadorDestino"
                                  ></app-garantia-idoneas-destinos>
      </p-tabPanel>

      <p-tabPanel header="{{ 'GARANTIASIDONEAS.LBL_MUNICIPIO' | translate}}"
                  *ngIf="garantiasIdoneas.idGarantiaIdonea && garantiasIdoneas.indicadorMunicipio">
        <app-garantia-idoneas-municipios [garantia]="garantiasIdoneas"
                                       *ngIf="garantiasIdoneas.idGarantiaIdonea &&
                                        garantiasIdoneas.indicadorMunicipio"
        ></app-garantia-idoneas-municipios>
      </p-tabPanel>

      <p-tabPanel header="{{ 'GARANTIASIDONEAS.LBL_ACTIVIDADES' | translate}}"
                  *ngIf="garantiasIdoneas.idGarantiaIdonea && garantiasIdoneas.indicadorActividades">
        <app-garantia-idoneas-actividades [garantia]="garantiasIdoneas"
                                         *ngIf="garantiasIdoneas.idGarantiaIdonea &&
                                        garantiasIdoneas.indicadorActividades"
        ></app-garantia-idoneas-actividades>
      </p-tabPanel>

      <p-tabPanel header="{{ 'GARANTIASIDONEAS.LBL_PRODUCTO' | translate}}"
                  *ngIf="garantiasIdoneas.idGarantiaIdonea">
        <app-garantia-idoneas-producto [garantia]="garantiasIdoneas"
                                          *ngIf="garantiasIdoneas.idGarantiaIdonea "
        ></app-garantia-idoneas-producto>
      </p-tabPanel>

      <p-tabPanel header="{{ 'GARANTIASIDONEAS.LBL_TIPOPRODUCTOR' | translate}}"
                  *ngIf="garantiasIdoneas.idGarantiaIdonea">
        <app-garantia-idoneas-tipo-producto [garantia]="garantiasIdoneas"
                                       *ngIf="garantiasIdoneas.idGarantiaIdonea "
        ></app-garantia-idoneas-tipo-producto>
      </p-tabPanel>


      <p-tabPanel header="{{ 'GARANTIASIDONEAS.LBL_PERIODOGRACIA' | translate}}"
                  *ngIf="garantiasIdoneas.idGarantiaIdonea && garantiasIdoneas.indicadorPeriodoGracia">
        <app-garantia-idoneas-periodo-gracia [garantia]="garantiasIdoneas"
                                       *ngIf="garantiasIdoneas.idGarantiaIdonea && garantiasIdoneas.indicadorPeriodoGracia "
        ></app-garantia-idoneas-periodo-gracia>
      </p-tabPanel>
    </p-tabView>

  </p-accordionTab>

  <p-accordionTab header="{{'GARANTIASIDONEAS.LBL_INFOCOBROPERFIL'|translate}}"
                  [selected]="tabSeleccionado === 'COBROPORPERFILRIESGO'"
                  *ngIf="garantiasIdoneas && garantiasIdoneas.indicadorCobroPerfil">

    <app-cobros-perfiles-riesgos [garantiaIdonea]="garantiasIdoneas"
    ></app-cobros-perfiles-riesgos>
  </p-accordionTab>


</p-accordion>


<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar(true)"
              pButton></button>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="garantia-idoneas">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
